import get from 'lodash.get'
import map from 'lodash.map'
import merge from 'lodash.merge'

export default { get, map, merge }
